import React, { useCallback } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import BodyText from 'LuxKit/Typography/BodyText'

type Props = {
  title: string
  description: string
}

function VoucherDetailsModal({ title, description }: Props) {
  const modalElement = useModalElementContext()

  const onClose = useCallback(() => {
    modalElement.resolve(undefined)
  }, [modalElement])

  return <ModalBase size="L">
    <ModalHeader
      title={title}
      onCloseButtonClick={onClose}
    />
    <ModalBody>
      <ModalContent>
        <BodyText variant="medium" wrap="pre-wrap">{description}</BodyText>
      </ModalContent>
    </ModalBody>
  </ModalBase>
}

export default VoucherDetailsModal
